import React from 'react'
import classnames from "classnames";
import ReactTooltip from "react-tooltip";

function LoadMore({ childrenMetadata, setParameters, fetchChildren, LIMIT}) {
    return (
        <div
        onClick={() => {
          setParameters(prevState => {
            const folderParams = {
              ...prevState,
              limit: +prevState.limit + LIMIT
            };

            fetchChildren(folderParams);

            return folderParams;
          });
        }}
        className={classnames("text-info cp ml-20 pagination", {
          hidden: !childrenMetadata?.has_more
        })}
      >
        <ReactTooltip />
        <i
          data-tip="Load More Files..."
          title="Load More Files..."
          className="fas fa-ellipsis-h"
        ></i>
      </div>
    )
}

export default LoadMore
